<template>
  <AccountGrid>
    <div>
      <LoadingElement v-if="isLoading && !isEditMode()" />
      <div v-else class="flex flex-col gap-y-8 lg:gap-y-12">
        <div class="flex flex-col gap-y-4">
          <CommonLabel
            class="text-3xl font-medium text-dark-blue"
            path="BWF/shop/account/overview/myProducts"
          />
          <CommonLabel path="BWF/shop/account/overview/productsExplanationTextLabel" />
        </div>

        <template v-if="!registeredProductsList || isEditMode()">
          <EditableArea :content="empty" />
        </template>

        <ul v-if="registeredProductsList" class="flex flex-col gap-y-4">
          <li v-for="product in registeredProductsList" :key="product.id">
            <AccountProductCard
              :product="product"
              @product-spare-parts="sparePartServiceModal.open()"
              @remove-product="openRemoveModal(product.registrationId)"
            />
          </li>
        </ul>

        <div class="flex justify-center">
          <button class="btn btn-blue w-full lg:w-auto">
            <NuxtLink :to="marketSetupAdmin?.productRegistrationPage ?? ''">
              <CommonLabel path="BWF/shop/account/products/registerNewProduct" />
            </NuxtLink>
          </button>
        </div>
      </div>

      <EditableArea :content="sparePartModalArea" :custom-view="EmptyArea" />
      <ModalComponent
        :content="sparePartModalArea"
        :controller="sparePartServiceModal"
        :text-centered="true"
      >
      </ModalComponent>

      <EditableArea :content="removeProductModalArea" :custom-view="EmptyArea" />
      <ModalComponent
        :content="removeProductModalArea"
        :controller="removeProductServiceModal"
        :text-centered="true"
      >
        <template #primaryAction>
          <button class="btn btn-ghost w-full" @click="removeProductServiceModal.close()">
            <CommonLabel path="BWF/shop/shared/cancel" />
          </button>
        </template>

        <template #secondaryAction>
          <button class="btn btn-blue w-full">
            <CommonLabel
              path="BWF/shop/account/products/removeProductActionLabel"
              @click="onRemoveRegisteredProduct()"
            />
          </button>
        </template>
      </ModalComponent>
    </div>
  </AccountGrid>
</template>

<script setup>
import AccountGrid from "~/templates/components/account/AccountGrid.vue";
import EmptyArea from "~/templates/areas/EmptyArea.vue";
import CommonLabel from "~/templates/components/CommonLabel.vue";
import AccountProductCard from "~/templates/components/account/AccountProductCard.vue";
import { EditableArea } from "@magnolia/vue-editor";
import { isEditMode } from "~/utils/content/magnolia";
import ModalComponent from "~/templates/components/ModalComponent.vue";
import { useRegisteredProducts } from "~/composables/shop/useRegisteredProducts";
import LoadingElement from "~/templates/elements/LoadingElement.vue";

const isLoading = ref(true);
defineProps(["empty", "sparePartModalArea", "removeProductModalArea"]);
const sparePartServiceModal = useModal();
const removeProductServiceModal = useModal();

const { marketSetupAdmin } = useMarketSetup();

const { registeredProductsList, removeRegisteredProduct, fetchRegisteredProducts } =
  useRegisteredProducts();
const currentRemovalId = ref("");

const openRemoveModal = async (registrationId) => {
  currentRemovalId.value = registrationId;
  removeProductServiceModal.open();
};
const onRemoveRegisteredProduct = () => {
  removeRegisteredProduct(currentRemovalId.value);
  removeProductServiceModal.close();
};

onMounted(async () => {
  await fetchRegisteredProducts();
  isLoading.value = false;
});
</script>
